var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',{staticClass:"content-text line-spacing",attrs:{"emoji":false,"html":_vm.trustedContent,"source":_vm.sanitize(_vm.text.body)}})}
var staticRenderFns = []

export { render, staticRenderFns }